<template>
  <Card
    :class="{
      'card-job-find-list': true,
      bordered: bordered,
      compact: compact
    }"
  >
    <template>
      <MediaItem
        v-if="job.company"
        :src="job.company.logoImage.thumbnailSizeUrl"
        image-size="small"
        gap-size="medium"
      >
        <div class="card-job-find-list__title">
          <span class="card-job-find-list__position">{{ job.title }}</span>
          <BulletInlineList :size="13" class="text-gray-600 fw500">
            <span>{{ job.company.name }}</span>
            <span v-if="job.location && !job.isRemote">{{
              job.location.shortName
            }}</span>
            <span v-if="job.isRemote">Remote</span>
            <span v-for="type in job.jobPositionTypes" :key="type">{{
              jobPositionTypeLabelById(type)
            }}</span>
          </BulletInlineList>
        </div>
      </MediaItem>
    </template>
    <a
      :href="extJobUrl"
      class="card-job-find-list__link"
      target="_blank"
      :alt="`Go to job: ${job.title}`"
    ></a>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import MediaItem from '@/components/MediaItem'
import BulletInlineList from '@/components/BulletInlineList'

export default {
  name: 'JobsListWidgetItem',
  components: {
    Card,
    MediaItem,
    BulletInlineList
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    extJobUrl() {
      return process.env.BASE_URL + this.job.url
    }
  },
  methods: {
    jobPositionTypeLabelById(id) {
      const type = this.$store.getters['meta/jobPositionTypeById'](id)
      return type && type.label
    }
  }
}
</script>

<style lang="scss">
.card-job-find-list {
  padding: rem(24px);
  height: auto;
  @include transition(0.03s);

  &:hover,
  &:active,
  &:focus {
    transform: translateY(0);
    box-shadow: $box-shadow-lighter;

    .card-job-find-list__position {
      text-decoration: none;
      color: $blue-900;
    }
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
  }

  .media-item {
    @include media-breakpoint-down(sm) {
      flex-direction: column;
      align-items: flex-start !important;
    }

    &__logo {
      @include media-breakpoint-down(sm) {
        margin-bottom: rem(16px);
      }
    }

    &__content {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      position: relative;

      @include media-breakpoint-down(sm) {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  &__title {
    padding-right: rem(20px);

    @include media-breakpoint-down(sm) {
      padding-right: 0;
    }
  }

  &__date {
    min-width: 120px;
  }

  &__position {
    display: block;
    font-size: rem(20px);
    font-weight: 500;
    letter-spacing: rem(-0.5px);
    line-height: 1.4;
    color: $gray-900;
    overflow: hidden;
    text-overflow: ellipsis;
    @include transition(0.1s);

    @include media-breakpoint-down(md) {
      font-size: rem(18px);
      max-height: rem(22px);
    }

    @include media-breakpoint-down(sm) {
      line-height: 1.2;
      -webkit-line-clamp: 3;
      max-height: rem(63px);
      margin-top: 0;
    }
  }

  &.bordered {
    border: 1px solid #caccd2;
  }

  &.compact {
    .card-job-find-list__position {
      font-size: rem(16px) !important;
    }
  }
}
</style>
